let counter = 0;
const interval = setInterval(() => {
    const template = window.BSS_B2B?.shopData?.template;
    if (template === "product") {
        const container = document.querySelector(".product__info-wrapper");
        if (!container) return;
        const checkout = container.querySelector(".shopify-payment-button");
        if (!checkout) return;
        checkout.style.display = "none";
        clearInterval(interval);
    }
    counter += 100;
    if (counter >= 10000) {
        clearInterval(interval);
    }
}, 100);

const soldoutBtn = document.querySelector(
  ".product-form__submit.button.button--full-width"
);

if (
  soldoutBtn &&
  soldoutBtn.textContent.trim().toLowerCase() === "sold out"
) {
  soldoutBtn.textContent =
    "Sold Out – Temporarily out of stock. New inventory coming soon!";
}

function prefixB2BPriceLabel(element, label) {
  if (!element) return;

  const text = element.textContent.replace(/\s+/g, " ").trim();
  if (!text || text.toLowerCase().startsWith(label.toLowerCase())) return;
  if (element.querySelector(".bss-price-label")) return;

  const labelNode = document.createElement("span");
  labelNode.className = "bss-price-label";
  labelNode.textContent = `${label} `;
  element.prepend(labelNode);
}

function escapeB2BPriceText(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

function getB2BMoneyValues(text) {
  return text
    .replace(/\s+/g, " ")
    .match(/(?:[$£€]\s?\d[\d,]*(?:\.\d{2})?|\d[\d,]*(?:\.\d{2})?\s?(?:USD|GBP|EUR))/g) || [];
}

function isLoggedOutB2BPrice(price) {
  const context = typeof price.closest === "function"
    ? price.closest(".card__information, .product__info-wrapper, .quick-add-modal__content-info")
    : null;
  return Boolean((context || price).querySelector(".bss-custom-ltsp"));
}

function markB2BPriceReady(price, regularPrice, wholesalePrice) {
  price.classList.add("bss-price-labels-ready");

  [regularPrice, wholesalePrice].forEach((element) => {
    const line = element?.parentElement && element.parentElement !== price ? element.parentElement : element;
    if (line) line.style.display = "block";
  });

  if (wholesalePrice) {
    wholesalePrice.style.color = "rgb(var(--color-foreground))";
  }
}

function rebuildB2BPrice(price, values) {
  const msrp = escapeB2BPriceText(values[0]);
  const wholesale = escapeB2BPriceText(values[values.length - 1]);

  price.classList.add("bss-price-labels-ready");
  price.innerHTML = `
    <div class="price__container bss-price-labels-fallback">
      <div class="bss-price-line bss-msrp-line">
        <s class="price-item price-item--regular">MSRP ${msrp}</s>
      </div>
      <div class="bss-price-line bss-wholesale-line">
        <span class="price-item price-item--sale price-item--last">Wholesale Price ${wholesale}</span>
      </div>
    </div>
  `;
}

function labelB2BPrice(price) {
  if (!price || isLoggedOutB2BPrice(price)) return;

  const text = price.textContent.replace(/\s+/g, " ").trim();
  if (!text || (text.includes("MSRP") && text.includes("Wholesale Price"))) {
    price.classList?.add("bss-price-labels-ready");
    return;
  }

  const regularPrice = price.querySelector("s.price-item--regular, del.price-item--regular, s, del, .price-item--regular");
  const wholesalePrice = price.querySelector(".price-item--sale, .price-item--last");

  if (regularPrice && wholesalePrice) {
    prefixB2BPriceLabel(regularPrice, "MSRP");
    prefixB2BPriceLabel(wholesalePrice, "Wholesale Price");
    markB2BPriceReady(price, regularPrice, wholesalePrice);
    return;
  }

  const values = getB2BMoneyValues(text);
  if (values.length >= 2) {
    rebuildB2BPrice(price, values);
  }
}

function labelB2BPrices() {
  document
    .querySelectorAll("[bss-b2b-product-price], .price--on-sale, .price")
    .forEach(labelB2BPrice);
}

function startB2BPriceLabeling() {
  labelB2BPrices();

  if (!document.body || window.bssPriceLabelObserver) return;

  let labelTimer;
  window.bssPriceLabelObserver = new MutationObserver(() => {
    window.clearTimeout(labelTimer);
    labelTimer = window.setTimeout(labelB2BPrices, 50);
  });
  window.bssPriceLabelObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startB2BPriceLabeling);
} else {
  startB2BPriceLabeling();
}

window.addEventListener("load", labelB2BPrices);
window.addEventListener("scroll", labelB2BPrices, { passive: true });
